export default __webpack_public_path__ + "static/photo10usluge-89dcfe1ea1d363aa67744ea149841b89.png";